export type DishesImportHistoryTranslation = {
  batch: string;
  close: string;
  delete: string;
  deleteConfirm: string;
  download: string;
  empty: string;
  errors: string;
  file: string;
  importedAt: string;
  importedBy: string;
  report: string;
  reportSubtitle: string;
  reportTitle: string;
  result: string;
  resultValue: string;
  rowsPerPage: string;
  title: string;
};

export type DishesImportTranslation = {
  definitionsSectionTitle: string;
  description: string;
  dishesAssigned: string;
  dishName: string;
  errorsTableTitle: string;
  errorTitle: string;
  fileName: string;
  groupsCreated: string;
  hint: string;
  history: DishesImportHistoryTranslation;
  imported: string;
  noErrors: string;
  partialTitle: string;
  perFileTitle: string;
  pickFile: string;
  reason: string;
  reset: string;
  rowNumber: string;
  selectedFiles: string;
  setsImported: string;
  sheet: string;
  skipped: string;
  subgroupsCreated: string;
  successTitle: string;
  tabs: {
    pptx: string;
    xlsx: string;
  };
  title: string;
  totalRows: string;
  upload: string;
  uploadFailed: string;
  uploadingProgress: string;
};

export const dishesImportTranslation: DishesImportTranslation = {
  definitionsSectionTitle: 'Utworzone zestawy',
  description:
    'Wgraj jeden lub wiele plików XLSX zgodnych z szablonem importera. Arkusz „Dania" (albo pierwszy ' +
    'arkusz) z nagłówkami dokładnie jak w specyfikacji — Nazwa dania, Dział, Rodzaj dania, Sezonowość, ' +
    'Tagi, Gramatura, Gramatura jednostka, flagi dietetyczne, FC, ceny, porcja. ' +
    'Opcjonalne arkusze „Zestawy" i „Struktura" tworzą dodatkowo definicje grup wraz z podgrupami ' +
    'i przypisaniem dań. Pliki wgrywane są po kolei — jeśli danie o tej samej nazwie jest w kilku ' +
    'plikach, struktura podpina się do już istniejącego dania.',
  dishesAssigned: 'Dań w podgrupach',
  dishName: 'Nazwa dania / zestawu',
  errorsTableTitle: 'Lista błędów',
  errorTitle: 'Import nie powiódł się',
  fileName: 'Plik',
  groupsCreated: 'Grup',
  hint:
    'Każdy wiersz przetwarzany jest niezależnie. ' +
    'Wiersze z błędami są pomijane, reszta wgrywa się normalnie. ' +
    'Zestaw powstaje w całości albo wcale — pojedyncze nierozpoznane danie tylko trafia na listę błędów.',
  history: {
    batch: 'plik {{position}} z {{size}} w partii',
    close: 'Zamknij',
    delete: 'Usuń z historii',
    deleteConfirm:
      'Usunąć „{{fileName}}” z historii importów? Znikną zapisany plik i raport. ' +
      'Dania i zestawy wgrane tym importem zostają w katalogu.',
    download: 'Pobierz plik',
    empty: 'Nie wgrano jeszcze żadnego pliku.',
    errors: 'Błędy',
    file: 'Plik',
    importedAt: 'Data',
    importedBy: 'Osoba',
    report: 'Raport',
    reportSubtitle: '{{date}} · {{person}}',
    reportTitle: 'Raport importu: {{fileName}}',
    result: 'Wynik',
    resultValue: 'dań: {{dishes}} · zestawów: {{sets}}',
    rowsPerPage: 'Wierszy na stronie',
    title: 'Historia importów',
  },
  imported: 'Wgrano',
  noErrors: 'Brak błędów — wszystko wgrane.',
  partialTitle: 'Import zakończony z błędami',
  perFileTitle: 'Wynik per plik',
  pickFile: 'Wybierz pliki XLSX',
  reason: 'Powód odrzucenia',
  reset: 'Wyczyść',
  rowNumber: 'Wiersz',
  selectedFiles: 'Wybrano plików: {{count}}',
  setsImported: 'Zestawów',
  sheet: 'Arkusz',
  skipped: 'Pominięto',
  subgroupsCreated: 'Podgrup',
  successTitle: 'Import zakończony pomyślnie',
  tabs: {
    pptx: 'Z prezentacji oferty (PPTX)',
    xlsx: 'Z arkusza (XLSX)',
  },
  title: 'Import dań i zestawów',
  totalRows: 'Wszystkich wierszy',
  upload: 'Wgraj do bazy',
  uploadFailed: 'Nie udało się wgrać pliku',
  uploadingProgress: 'Wgrywanie {{current}}/{{total}}...',
};
